<template>
    <button :class="['r-button', type]" @click="createGame">
        <slot></slot>
    </button>
</template>

<script>
export default {
    name: 'RButton',
    props: {
        type: {
            type: String,
            default: 'default'
        }
    },
    methods: {
        
    }
}
</script>

<style scoped>

.r-button:hover, .r-button:focus {
    background-position: right;
    transform: scale(1.05);
}

.default {
    padding: 0.5rem 1rem;
    color: white;
    background: linear-gradient(270deg, rgb(82, 156, 82), rgb(131, 131, 80), rgb(33, 33, 183), rgb(61, 131, 136), rgb(168, 54, 168));
    border: none;
    border-radius: 0.375rem;
    font-weight: bold;
    transition: background-position 0.5s, transform 0.3s;
    background-size: 300% 300%;
    color: white;
    cursor: pointer;
}

.gray {
    padding: 0.5rem 1rem;
    color: white;
    background: linear-gradient(270deg, rgb(82, 82, 82), rgb(131, 131, 131), rgb(33, 33, 33), rgb(61, 61, 61), rgb(46, 46, 46));
    border: none;
    border-radius: 0.375rem;
    font-weight: bold;
    transition: background-position 0.5s, transform 0.3s;
    background-size: 300% 300%;
    color: white;
    cursor: pointer;
}

</style>